import { modeloStyleType } from '../../../../service/checklistStyle';
import { trackEventMatomo } from '../../../../helpers/matomo';
import { useTranslation } from 'react-i18next';
import { Stack, TextField, Typography } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

type props = {
  setObjectToEdit: Function,
  objectToEdit: modeloStyleType,
};

export default function StyleConfig({
  objectToEdit,
  setObjectToEdit
}: props) {
  const { t } = useTranslation('translation');


  function getBase64(file: File, cb: (s: string) => void) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result as string);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  return (
    <>
      <Stack
        width={'100%'}
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={0}
        sx={{ padding: '10px' }}
      >
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0.5}
        >
          <label className="checkbox">
            <input
              onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona texto')}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, enablePosMessage: event.target.checked })}
              checked={objectToEdit.enablePosMessage}
              type="checkbox"
            />
          </label>
          <Typography variant='body1' sx={{ fontWeight: 600, color: 'gray' }}>{t('checklists.includeMessageAndPhotoAfterSurvey')}</Typography>
        </Stack>
        {objectToEdit.enablePosMessage &&
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            width={'100%'}
            sx={{ backgroundColor: '#E8E8E8', padding: '10px' }}
          >
            <TextField
              onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona texto')}
              inputProps={{
                maxLength: 1000,
              }}
              helperText={`${objectToEdit.messageAfter?.length as any}/1000`}
              fullWidth
              label={t('checklists.message')}
              value={objectToEdit.messageAfter}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, messageAfter: event.target.value })}
              multiline
              rows={3}
            />
            {!objectToEdit.imageAfter
              ?
              <>
                <span className='button is-success is-small'>
                  <input
                    accept="image/png, image/jpeg"
                    value={''}
                    id="img"
                    name="img"
                    multiple={true}
                    className="file-input"
                    type="file"
                    onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona imagem')}
                    onChange={(event) => {
                      if (event.target.files) {
                        Array.from(event.target.files).map(e => getBase64(e, (i) => setObjectToEdit({ ...objectToEdit, imageAfter: i })));
                      }
                    }}
                  />
                  {t('users.userRegister.selectMessage')}&nbsp;
                  <AddPhotoAlternateIcon />
                </span>
              </>
              : <Stack
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0.5}
              >
                <img alt='' width={'100px'} src={objectToEdit.imageAfter} />
                <RemoveCircleIcon color='error'
                  onClick={() => {
                    setObjectToEdit({ ...objectToEdit, imageAfter: null });
                  }} />
              </Stack>}
          </Stack>}
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0.5}
        >
          <label className="checkbox">
            <input
              onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona texto')}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, enablePostMessage: event.target.checked })}
              checked={objectToEdit.enablePostMessage}
              type="checkbox" />
          </label>
          <Typography variant='body1' sx={{ fontWeight: 600, color: 'gray' }}>{t('checklists.includeMessageAndPhotoBeforeSurvey')}</Typography>
        </Stack>
        {
          objectToEdit.enablePostMessage &&
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            width={'100%'}
            sx={{ backgroundColor: '#E8E8E8', padding: '10px' }}
          >
            <TextField
              inputProps={{
                maxLength: 1000,
              }}
              helperText={`${objectToEdit.messageAfter?.length as any}/1000`}
              fullWidth
              label={t('checklists.message')}
              multiline
              rows={3}
              onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona texto')}
              value={(objectToEdit?.messageBefore as string)}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, messageBefore: event.target.value })}
            />
            {!objectToEdit.imageBefore
              ? <span className='button is-success is-small'>
                <input
                  onClick={() => trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'adiciona imagem')}
                  accept="image/png, image/jpeg"
                  value={''}
                  id="img"
                  name="img"
                  multiple={true}
                  className="file-input"
                  type="file"
                  onChange={(event) => {
                    if (event.target.files) {
                      Array.from(event.target.files).map(e => getBase64(e, (i) => setObjectToEdit({ ...objectToEdit, imageBefore: i })));
                    }
                  }}
                />
                {t('users.userRegister.selectMessage')}&nbsp;
                <AddPhotoAlternateIcon />
              </span>
              : <Stack
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0.5}
              >
                <img alt='' width={'100px'} src={objectToEdit.imageBefore} />
                <RemoveCircleIcon color='error'
                  onClick={() => {
                    setObjectToEdit({ ...objectToEdit, imageBefore: null });
                  }} />
              </Stack>
            }
          </Stack>
        }
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0.5}
        >
          <label className="checkbox">
            <input
              onClick={() => {
                trackEventMatomo('Configurar impressões form deslogado', 'click', 'checkbox', 'habilita redirecionar');
              }}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, enableLoop: event.target.checked, enableRedirect: false })}
              checked={objectToEdit.enableLoop}
              type="checkbox" />
          </label>
          <Typography variant='body1' sx={{ fontWeight: 600, color: 'gray' }}>{t('checklists.enableSurveyLoop')}</Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={0.5}
        >
          <label className="checkbox">
            <input
              onClick={() => {
                trackEventMatomo('Configurar impressões form deslogado', 'click', 'checkbox', 'habilita loop');
              }}
              onChange={(event) => {
                setObjectToEdit({ ...objectToEdit, enableRedirect: event.target.checked, enableLoop: false });
              }}
              checked={objectToEdit.enableRedirect}
              type="checkbox" />
          </label>
          <Typography variant='body1' sx={{ fontWeight: 600, color: 'gray' }}>Habilitar site de redirecionamento</Typography>
        </Stack>
        {objectToEdit.enableRedirect &&
          <Stack width={'100%'} style={{ backgroundColor: '#E8E8E8', padding: 10 }}>
            <TextField
              fullWidth
              size="small"
              label={'URL'}
              onClick={() => {
                trackEventMatomo('Configurar impressões form deslogado', 'click', 'input', 'habilita link');
              }}
              placeholder='https://www.example.com.br'
              value={(objectToEdit?.link as string)}
              onChange={(event) => setObjectToEdit({ ...objectToEdit, link: event.target.value })}
            />
          </Stack>}
      </Stack >
    </>
  );
}
